import { animated, useSpring } from '@react-spring/web';
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { LabelField, MyCheckbox, TextareaField } from "components";
import EmailsList from "components/ShareDocuments/Emails/EmailsList";
import { formatDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import React, { useEffect, useState } from "react";
import thousands from "thousands";
import { getRandColor } from "utils/emailRandomColors";
import { CheckFloatValue } from "../../../utils/functions";
import { fontConfig } from "theme/fontConfig";

const Review = ({ calculateConvenienceFeeAmount,...props }) => {
  const formik = props;
  const [noteAccordionExpanded, setNoteAccordionExpanded] = useState(false);
  const [emailAccordionExpanded, setEmailAccordionExpanded] = useState(false);
  const [installmentNote, setInstallmentNote] = useState("");
  const autoSetByInstallment = React.useRef(false);
  const currency = getCurrency();
  
  const sumOfDiscounts = formik?.values?.allData?.reduce((a, b) => {
    if (b.discount_type === "%" && b.discount) {
      // return a + (b?.charge?.amount * b.discount) / 100;
      return a + b.discount;
    }
    if (b.discount_type === "$" && b.discount) {
      return a + b.discount;
    } else {
      return 0;
    }
  }, 0);

  const sumOfDiscountsForDisplay = formik?.values?.allData?.reduce((a, b) => {
    if (b.discount_type === "%" && b.discount) {
      const preDiscountAmount = b?.originalAmount
        ? parseFloat(b.originalAmount)
        : b.discount < 100
        ? parseFloat(b?.charge?.amount || 0) / (1 - b.discount / 100)
        : parseFloat(b?.charge?.amount || 0);
      return a + (preDiscountAmount * b.discount) / 100;
    }
    if (b.discount_type === "$" && b.discount) {
      return a + b.discount;
    }
    return a;
  }, 0);
  const sumOfAmounts = formik.values?.allData?.reduce((a, b) => {
    return a + parseFloat(b?.charge?.amount);
  }, 0);
  const acutalTotal = parseFloat(formik?.values?.actual_total);

  const currentTotal = parseFloat(formik?.values?.current_total);

  const splittedAmount = parseFloat(formik?.values?.split_amount);

  const splitAmount = parseFloat(formik?.values?.values?.[0].split_amount);

  const sumAmounts = parseFloat(sumOfAmounts);

  const TotalSum = sumAmounts;
  const currentAmount = parseFloat(formik?.values?.current_amount);

  // const sumOfTaxes = formik?.values?.allData?.reduce((a, b) => {
  //   if (b.tax_type === "%" && b.tax_deductible) {
  //     return a + (b?.charge?.amount * b.tax_deductible) / 100;
  //   }
  //   if (b.tax_type === "$" && b.tax_deductible) {
  //     return a + b.tax_deductible;
  //   } else {
  //     return 0;
  //   }
  // }, 0);

  const sumOfTotalAmounts = TotalSum - sumOfDiscounts;
  // ?.toString()
  // .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const methods = (() => {
    const result = [];
    const v = formik?.values;

    if (parseFloat(v?.cash_payment) > 0) {
      result.push({ paymentMethod: "Cash", amount: v?.cash_payment });
    }
    if (parseFloat(v?.ach) > 0) {
      result.push({ paymentMethod: "ACH", amount: v?.ach, achId: v?.payments?.[0]?.ACH });
    }
    if (parseFloat(v?.creditCardAmount) > 0) {
      result.push({ paymentMethod: "Credit Card", amount: v?.creditCardAmount, last4: v?.last4 });
    }
    if (parseFloat(v?.onAccountCredit_payment) > 0) {
      result.push({ paymentMethod: "Credit On Account", amount: v?.onAccountCredit_payment });
    }

    // Custom payment methods stored as ${title}_payment
    const knownKeys = new Set(["cash_payment", "onAccountCredit_payment", "ach_payment", "credit card_payment"]);
    Object.entries(v || {}).forEach(([key, value]) => {
      if (!key.endsWith("_payment")) return;
      if (knownKeys.has(key)) return;
      const split = key.split("_payment");
      const name = split[0];
      const amount = parseFloat(value);
      if (amount > 0) {
        result.push({ paymentMethod: name, amount: value });
      }
    });

    return result;
  })();

  const totalValue =
    formik.values?.checks &&
    formik.values?.checks?.reduce(function (pre, curr) {
      return Number(pre) + Number(curr.amount);
    }, 0);
  const totalMethodsValue =
    methods &&
    methods?.reduce(function (pre, curr) {
      return Number(pre) + Number(curr.amount);
    }, 0);

  const totalPayment = [];
  if (formik?.values?.cash_payment) {
    totalPayment.push(Number(formik?.values?.cash_payment));
  }
  if (formik.values?.checks) {
    totalPayment.push(Number(totalValue));
  }
  if (formik?.values?.onAccountCredit_payment) {
    totalPayment.push(Number(formik?.values?.onAccountCredit_payment));
  }
  if (formik?.values?.creditCardAmount) {
    totalPayment.push(Number(formik?.values?.creditCardAmount));
  }
  if (formik?.values?.ach) {
    totalPayment.push(Number(formik?.values?.ach));
  }

  const paymentValues =
    methods && methods?.map((item) => parseFloat(item?.amount));
  const newPaymentsValues = paymentValues.filter(function (value) {
    return !Number.isNaN(value);
  });

  const sumofNewPayments = newPaymentsValues?.reduce(
    (sum, a) => sum + a?.amount,
    0
  );

  const sumOfMethods = methods?.reduce((sum, a) => sum + Number(a.amount), 0);
  const sumOfChecks =
    formik?.values?.checks?.length > 0
      ? formik?.values?.checks?.reduce((sum, a) => sum + Number(a?.amount), 0)
      : 0;

  const sumofPayments = totalPayment?.reduce(
    (partialSum, a) => Number(partialSum) + Number(a),
    0
  );

  const totalSumofValues = Number(sumOfMethods) + Number(sumOfChecks);

  // const totalSumofValues = sumofPayments;

  const getCommaSeperatedValue = (num) => {
    if (formik?.values?.convenient_fee_by === "member") {
      let sumValue =
        num +
          (isNaN(formik?.values?.convenient_fee)
            ? 0
            : parseFloat(formik?.values?.convenient_fee)) ?? 0;
      let newSumValue = CheckFloatValue(
        parseFloat(sumValue?.toString().replace(/,/g, ""))
      ).toLocaleString();
      return newSumValue;
    }
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const getstringwithoutconvenience = (num) => {
    return CheckFloatValue(parseFloat(num))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const getValueforAmount = (num) => {
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const totalSplittedAmount =
    formik?.values?.allData &&
    formik?.values?.allData?.map((item) => item?.charge?.amount);
  const sumOfSplittedAmount = totalSplittedAmount?.reduce(
    (partialSum, a) => partialSum + a,
    0
  );

  const totalAllDataDueAmount =
    formik?.values?.allData?.length > 0 &&
    formik?.values?.allData?.reduce(
      (accumulator, obj) => accumulator + obj.Charges?.amount_due,
      0
    );

  const convertedValue = parseInt(formik?.values?.actual_total ?? 0, 10);
  const totalWithPaid =
    formik.values?.values?.[0]?.is_splitted === false
      ? formik.values?.actual_total
      : formik.values?.values?.[0]?.charge?.amount -
        formik.values?.values?.[0]?.charge?.paid;

  const totalAmount =
    (formik.values?.type === "edit-charge" && formik.values?.values?.[0]?.charge?.paid) 
    ? (+formik.values?.actual_total - +formik.values?.values?.[0]?.charge?.paid)
    : formik.values.allData?.length > 0
    ? +totalAllDataDueAmount
    : formik.values?.values?.[0]?.charge?.paid === 0
    ? +formik.values?.actual_total
    : formik.values?.values?.[0]?.charge?.paid
    ? 
        (+formik.values?.values?.[0]?.is_splitted === false
          ? formik.values?.actual_total
          : Number(formik.values?.values?.[0]?.total_amount) -
            formik.values?.values?.[0]?.charge?.paid
        )
    : formik.values?.type === "edit-charge"
    ? +formik.values?.actual_total
    : formik.values?.amount_due === 0 || formik.values?.amount_due
    ? +formik.values?.amount_due
    : formik?.values?.allData?.[0]?.charge?.amount
    ? +sumOfSplittedAmount
    : formik?.values?.values?.[0]?.split_amount
    ? +formik?.values?.values?.[0]?.split_amount
    : formik?.values?.actual_total
    ? +formik.values?.actual_total
    : formik.values?.current_total
    ? +formik.values?.current_total
    : formik.values?.current_amount
    ? +formik.values?.current_amount
    : formik.values?.values?.[0]?.split_amount
    ? +formik.values?.values?.[0]?.split_amount
    : +formik.values?.values?.[0]?.total_amount ??
      +sumOfAmounts;

  const paidAmount = formik.values?.values?.[0]?.isRecurring
    ? +formik.values?.actual_total
    : totalSumofValues;


    const calculatedTotalAmount = numberFormat({number:(+totalAmount + +calculateConvenienceFeeAmount(formik?.values)), decimal: 2, style: "decimal"});

    const displayInstallmentMethod = () => {
      const creditCardMethod = methods?.find((item) => item?.paymentMethod?.toLowerCase() === "credit card");
      const achMethod = methods?.find((item) => item?.paymentMethod?.toLowerCase() === "ach");

      if((!creditCardMethod || !formik?.values?.allowCreditInstallment) && (!achMethod || !formik?.values?.allowAchInstallment)) return "";
      const currentMethod = formik?.values?.allowCreditInstallment ? creditCardMethod : achMethod;

      const cycles = formik?.values?.allowCreditInstallment ? formik?.values?.installmentCreditDetails?.cycle : formik?.values?.installmentAchDetails?.cycle;
      const startDate = formik?.values?.allowCreditInstallment ? formik?.values?.installmentCreditDetails?.startInstallment : formik?.values?.installmentAchDetails?.startInstallment;
      const amountOfEach = +currentMethod?.amount / cycles;
      const formatAmount = numberFormat({number:amountOfEach, decimal: 2, style: "currency"});
      const startInstallment = formatDate({date:startDate, formatType: "defaultWithUTC"});

      const valid = (currentMethod?.paymentMethod?.toLowerCase() === "credit card" && formik?.values?.allowCreditInstallment) || (achMethod?.paymentMethod?.toLowerCase() === "ach" && formik?.values?.allowAchInstallment);
      return valid ? `In ${cycles} monthly installments of ${formatAmount} each, starting on ${startInstallment}` : "";
  }

  useEffect(() => {
    const installmentNote = displayInstallmentMethod();
    setInstallmentNote(installmentNote);
    if(installmentNote) {
      autoSetByInstallment.current = true;
      formik.setFieldValue("comment_receipt", true);
      formik.setFieldValue("receipt_note", installmentNote);
    } else if (autoSetByInstallment.current) {
      autoSetByInstallment.current = false;
      formik.setFieldValue("comment_receipt", false);
      formik.setFieldValue("receipt_note", undefined);
    }
  }, [formik?.values?.allowCreditInstallment, formik?.values?.installmentCreditDetails?.cycle, formik?.values?.installmentCreditDetails?.startInstallment, formik?.values?.allowAchInstallment, formik?.values?.installmentAchDetails?.cycle, formik?.values?.installmentAchDetails?.startInstallment]);

  const addEmailsHandler = ({ type, email }) => {
    const savedEmails = formik?.values?.emailsReceipt ?? [];
    if(savedEmails?.some((savedEmail) => savedEmail.email === email)) return;
    formik.setFieldValue("emailsReceipt", [...savedEmails, {
      type,
      email,
      image: email.charAt(0).toUpperCase(),
      color: getRandColor(),
    }]);
  };
  const removeEmailHandler = (email) => {
    formik.setFieldValue("emailsReceipt", formik?.values?.emailsReceipt?.filter((item) => item.email!== email));
  };

  const calculateMethodWithConvenienceFee = (method) => {
    let total = 0;
    const paymentMethod = formik?.values?.allPaymentsMethods?.find(item => item?.type?.toLowerCase() === method?.paymentMethod?.toLowerCase())
    // if(paymentMethod?.coverConvenienceFee) {
    
const optionalKey = `${paymentMethod?._id}`;

    const isOptionalChecked = formik?.values?.[optionalKey] === false;



    if(paymentMethod?.coverConvenienceFee && !isOptionalChecked) {   
      const cvAmount = paymentMethod?.convenienceFeeInfo?.type === "%" ? (method?.amount * paymentMethod?.convenienceFeeInfo?.amount) / 100 : +paymentMethod?.convenienceFeeInfo?.amount;
      total = +cvAmount + +method?.amount;
    } else {
      total = method?.amount;
    }

    return numberFormat({number:total, decimal: 2, style: "currency"});
  }

  const contentSpring = useSpring({
    height: formik?.values?.emailOnReceipt ? 100 : 0,
    opacity: formik?.values?.emailOnReceipt ? 1 : 0,
    config: { mass: 1, tension: 200, friction: 24 },
  })

  return (
    <div className="review">
      <div className="review-two-col">
        {/* ── LEFT: Financial Summary ───────────────────── */}
        <div className="review-col-left">
          <div className="review-summary-card">
            <div className="review-card-title">Summary</div>

            <div className="review-row">
              <div className="review-label">Amount</div>
              <div className="review-value">
                {currency}
                {formik.values?.amount_due === 0 || formik.values?.amount_due
                  ? numberFormat({number:+formik.values?.amount_due, decimal: 2, style: "decimal"})
                  : formik?.values?.allData?.[0]?.charge?.amount
                  ? numberFormat({number:+sumOfSplittedAmount, decimal: 2, style: "decimal"})
                  : formik?.values?.values?.[0]?.split_amount
                  ? numberFormat({number:+formik?.values?.values?.[0]?.split_amount, decimal: 2, style: "decimal"})
                  : formik?.values?.actual_total
                  ? numberFormat({number:+formik.values?.actual_total, decimal: 2, style: "decimal"})
                  : formik.values?.current_total
                  ? numberFormat({number:+formik.values?.current_total, decimal: 2, style: "decimal"})
                  : formik.values?.current_amount
                  ? numberFormat({number:+formik.values?.current_amount, decimal: 2, style: "decimal"})
                  : formik.values?.values?.[0]?.split_amount
                  ? numberFormat({number:+formik.values?.values?.[0]?.split_amount, decimal: 2, style: "decimal"})
                  : numberFormat({number:(+formik.values?.values?.[0]?.total_amount), decimal: 2, style: "decimal"})
                    ?? numberFormat({number:+sumOfAmounts, decimal: 2, style: "decimal"})}
              </div>
            </div>

            <div className="review-row">
              <div className="review-label">Discount</div>
              <div className="review-value">
                {formik?.values?.values?.[0]?.discount && (formik?.values?.allData?.length ?? 0) <= 1
                  ? (
                    <>
                      {formik?.values?.values?.[0]?.discount_type === "$" ? currency : ""}
                      {numberFormat({number:+formik?.values?.values?.[0]?.discount, decimal: 2, style: "decimal"})}
                      {formik?.values?.values?.[0]?.discount_type === "%" ? "%" : ""}
                    </>
                  )
                  : sumOfDiscountsForDisplay
                  ? (
                    <>
                      {currency}
                      {numberFormat({number:+sumOfDiscountsForDisplay, decimal: 2, style: "decimal"})}
                    </>
                  )
                  : 0}
              </div>
            </div>

            <div className="review-row review-row--no-border">
              <div className="review-label">Convenience fee</div>
              <div className="review-value">
                {numberFormat({number:calculateConvenienceFeeAmount(formik?.values), decimal: 2, style: "currency"})}
              </div>
            </div>

            <hr className="hr-div" />

            <div className="review-row">
              <div className="review-label">Paid</div>
              <div className="review-value">{numberFormat({number:paidAmount, decimal: 2, style: "currency"})}</div>
            </div>

            <div className="review-row review-row--total">
              <div className="review-label">Payment Total</div>
              <div className="review-value review-total-amount">{currency}{calculatedTotalAmount}</div>
            </div>

            <div className="review-row review-row--remaining">
              <div className="review-label">Due Now</div>
              <div className="review-value review-total-amount">
                {currency}
                {formik.values?.allData?.length > 0
                  ? thousands(
                      (totalAllDataDueAmount - totalSumofValues).toFixed(2) === "-0.00"
                        ? "0.00"
                        : (totalAllDataDueAmount - totalSumofValues).toFixed(2)
                    )
                  : formik.values?.values?.[0]?.charge?.paid === 0
                  ? numberFormat({number:(+formik.values?.actual_total - totalSumofValues), decimal: 2, style: "decimal"})
                  : formik.values?.values?.[0]?.charge?.paid
                  ? numberFormat({number:(+totalAmount - +paidAmount), decimal: 2, style: "decimal"})
                  : formik.values?.values?.[0]?.isRecurring
                  ? numberFormat({number:(formik.values?.actual_total - formik.values?.actual_total), decimal: 2, style: "decimal"})
                  : formik.values?.type === "edit-charge"
                  ? numberFormat({number:(formik.values?.actual_total - (totalSumofValues ?? 0.0)), decimal: 2, style: "decimal"})
                  : numberFormat({number:(formik?.values?.amount_due
                      ? formik?.values?.amount_due
                      : formik?.values?.actual_total - (totalSumofValues ?? 0.0)
                    ), decimal: 2, style: "decimal"}) ?? "0.00"}
              </div>
            </div>
            {(() => {
              const totalPaid =
                (+formik?.values?.creditCardAmount || 0) +
                (+formik?.values?.ach || 0) +
                (+formik?.values?.cash_payment || 0) +
                (+formik?.values?.onAccountCredit_payment || 0) +
                (formik?.values?.checks?.reduce((s, c) => s + (+c?.amount || 0), 0) || 0) +
                Object.entries(formik?.values || {})
                  .filter(([key, val]) => key.endsWith("_payment") && !["cash_payment", "onAccountCredit_payment", "ach_payment"].includes(key) && typeof val === "number" && !key.includes("credit") && !key.includes("ach") && !key.includes("cash"))
                  .reduce((sum, [, val]) => sum + (+val || 0), 0);
              return totalPaid > (+totalAmount || 0);
            })() && (
              <div style={{ color: "#e53e3e", fontSize: 12, fontFamily: fontConfig.FinanceReviewTextFont.family, fontWeight: 500, marginTop: 6 }}>
                Payment exceeds {formik.values?.allData?.length > 1 ? "charges" : "charge"} amount
              </div>
            )}
          </div>
        </div>

        {/* ── RIGHT: Payment + Notes ────────────────────── */}
        <div className="review-col-right">
          <div className="second-pr review-right-card">
            <div className="review-methods-title">Payment Method</div>
            {formik?.values?.selectedUpdatePayDataMethod && (
              <div className="review-method-row">
                <div className="review-method-name">
                  {formik?.values?.selectedUpdatePayDataMethod.toString().replace(/_/g, " ")}
                </div>
                <div className="review-method-amount">
                  {currency}{isNaN(convertedValue) ? "0.00" : convertedValue?.toString()}
                </div>
              </div>
            )}
            {!formik?.values?.values?.[0]?.isRecurring && methods?.map((item) => (
              <div className="review-method-row" key={item.paymentMethod}>
                {!!item?.amount && item?.amount !== "" && (
                  <>
                    <div className="review-method-name">
                      <span className="mr-2">
                        {item?.paymentMethod && item.amount ? item?.paymentMethod.replace(/_/g, " ") : ""}
                      </span>
                      {(item?.paymentMethod?.toLowerCase() === "credit card" && formik?.values?.allowCreditInstallment && installmentNote) ? `(${installmentNote}) ` : ""}
                      {(item?.paymentMethod?.toLowerCase() === "ach" && formik?.values?.allowAchInstallment && installmentNote) ? `(${installmentNote}) ` : ""}
                    </div>
                    <div className="review-method-amount">
                      {calculateMethodWithConvenienceFee(item)}
                    </div>
                  </>
                )}
              </div>
            ))}
            {formik?.values?.checks?.map((item, checkIdx) => (
              <div className="review-method-row" key={`check-${checkIdx}`}>
                {parseFloat(item?.amount) > 0 && (
                  <>
                    <div className="review-method-name">{item?.paymentMethod?.replace(/_/g, " ")}{" "}</div>
                    <div className="review-method-amount">
                      {calculateMethodWithConvenienceFee(item)}
                    </div>
                  </>
                )}
              </div>
            ))}

          </div>
        </div>

      </div>

      {/* ── BOTTOM: Notes & Receipt ───────────────────── */}
      <div className="review-bottom-card">
        <div className="review-bottom-inner">
          <div className="finance-accordian-container">
            <Accordion
              className="finance-accordian"
              expanded={noteAccordionExpanded}
              onChange={(e, newExpanded) => setNoteAccordionExpanded(newExpanded)}
            >
              <AccordionSummary
                className={
                  noteAccordionExpanded
                    ? "finance-accordian-header-expanded"
                    : "finance-accordian-header"
                }
                expandIcon={
                  <ExpandMoreIcon
                    style={!noteAccordionExpanded ? { color: "#b5b5c3" } : { color: "#ffff" }}
                  />
                }
              >
                <LabelField title="Add Note" style={{ margin: 0, cursor: "pointer" }} />
              </AccordionSummary>
              <AccordionDetails>
                <div style={{ width: "100%", marginTop: 16, marginBottom: 16 }}>
                  <div className="review-checkbox-row pb-2" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <MyCheckbox
                      name="comment_receipt"
                      title="Comment on receipt"
                      handlechange={(event) => {
                        formik.setFieldValue("comment_receipt", event.target.checked);
                      }}
                      checked={formik?.values?.comment_receipt}
                      titleStyles={{ color: "#1a1e2e", fontWeight: "500", fontSize: 14 }}
                    />
                  </div>
                  <TextareaField
                    {...{
                      formik,
                      name: `receipt_note`,
                      placeholder: "Note text",
                      style: { resize: "none", minHeight: "100px" },
                      value: formik?.values?.receipt_note,
                      titleStyle: { color: "#1a1e2e", fontWeight: "500", fontSize: 14 },
                    }}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          </div>

          <div className="finance-accordian-container">
            <Accordion
              className="finance-accordian"
              expanded={emailAccordionExpanded}
              onChange={(e, newExpanded) => setEmailAccordionExpanded(newExpanded)}
            >
              <AccordionSummary
                className={
                  emailAccordionExpanded
                    ? "finance-accordian-header-expanded"
                    : "finance-accordian-header"
                }
                expandIcon={
                  <ExpandMoreIcon
                    style={!emailAccordionExpanded ? { color: "#b5b5c3" } : { color: "#ffff" }}
                  />
                }
              >
                <div className="finance-accordian-header-row">
                  <div
                    className="finance-accordian-header-toggle"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <MyCheckbox
                      name="emailOnReceipt"
                      title="Email receipt"
                      handlechange={(event) => {
                        formik.setFieldValue("emailOnReceipt", event.target.checked);
                        setEmailAccordionExpanded(event.target.checked);
                      }}
                      checked={formik?.values?.emailOnReceipt}
                      style={{ margin: 0, alignItems: "center" }}
                    />
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div style={{ width: "100%", marginTop: 16, marginBottom: 16 }}>
                  <animated.div style={{ overflow: 'hidden', ...contentSpring }}>
                    <div className="transaction__email-receipt">
                      <div className="transaction__email-receipt-wrapper">
                        <EmailsList
                          addEmailsHandler={addEmailsHandler}
                          list={formik?.values?.emailsReceipt}
                          removeEmail={removeEmailHandler}
                          placeholder={!formik?.values?.emailsReceipt?.length ? "Enter Emails" : ""}
                        />
                      </div>
                    </div>
                  </animated.div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
